<template>
    <layout v-bind:user="user" v-bind:company="company" :title="pageTitle" @selectList="displaySelectedBrand($event)">
        <main class="ly_main"><div class="wrap"><div class="inner">
            <!--Heading-->
            <h1 class="heading_page-title flex _y-center">
                <div class="main"><span>{{pageTitle}}</span></div>
                <div class="controller flex _right _y-center">
                    <div v-if="pageType == 1 || pageType == 2 || pageType == 5">
                        <button class="btn_link _cancel md_icon-text" v-on:click="clickNotLoginList()">
                            <div class="inner">
                                <span><div class="icon"><SvgIconFile /></div>NotLoginList</span>
                            </div>
                        </button>
                    </div><!--/.add-->
                    <div class="form_search">
                        <form v-on:submit.prevent="search">
                            <input type="search" v-model="free_text">
                            <label for="submit-btn" class="md_svg-icon">
                                <SvgIconSearch />
                            </label>
                            <input type="submit" id="submit-btn">
                        </form>
                    </div><!--/.search-->
                </div><!--/.controller-->
            </h1><!--/.heading_page-title-->
            <!--ShopList-->
            <div class="md_common-bl" id="bland-list">
                <div class="inner">
                    <div class="table_common _use-checkbox">
                        <table>
                            <thead>
                                <tr>
                                    <th class="_pointer" @click="clickSort('id')">ID {{getTriangle('id')}}</th>
                                    <th class="_pointer" @click="clickSort('name')">運営会社名 {{getTriangle('name')}}</th>
                                    <th class="_pointer" @click="clickSort('phonetic')">フリガナ {{getTriangle('phonetic')}}</th>
                                    <th class="_pointer" @click="clickSort('email')">メールアドレス {{getTriangle('email')}}</th>
                                    <th class="_pointer" @click="clickSort('count')">登録ブランド数 {{getTriangle('count')}}</th>
                                    <th class="icon"></th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="company in companiesList" :key="company.id">
                                    <td>{{company.id}}</td>
                                    <td><Link class="" :href="route(linkToList)" :data="{company_id: company.id}">{{company.name}}</Link></td>
                                    <td>{{company.phonetic}}</td>
                                    <td>{{company.user_email}}</td>
                                    <td style="text-align: center;">{{company.count}}</td>
                                    <th class="icon">
                                        <a class="btn_svg-icon" v-on:click="clickDeleteCompany(company)">
                                            <SvgIconDelete />
                                        </a>
                                    </th>
                                </tr>
                            </tbody>
                        </table>
                        <pagination v-if="showPagination" :list="companies" />
                    </div><!--/.table_common-->
                </div><!--/.md_common-bl-->
                <AlertModal
                    v-if="showAlertModal"
                    @close="closeAlertModal"
                    :title="alert_modal_title"
                    :message="alert_modal_message"
                    :mode="alert_modal_mode"
                />
                <ConfirmModalWithPromise ref="confirmModal" />
            </div>
        </div></div><div class="heading_page-title-en"><span>{{backName}}</span></div></main>
    </layout>
</template>
<script>
    import AdminLayout from '@/Layouts/AdminLayout'
    import Pagination from '@/components/Admin/Pagination'
    import AlertModal from '@/components/Admin/ComponentList/AlertModal'
    import ConfirmModalWithPromise from '@/components/Admin/ComponentList/ConfirmModalWithPromise'
    import { Inertia } from '@inertiajs/inertia'
    import { reactive } from 'vue'
    import { Link } from '@inertiajs/inertia-vue3'

    //Svg
    import SvgIconSearch from '@/components/EndUser/svg/SvgIconSearch'
    import SvgIconDelete from '@/components/EndUser/svg/SvgIconDelete'
    import SvgIconFile from '@/components/EndUser/svg/SvgIconFile'

    import ScrollHint from 'scroll-hint';

    export default {
        components: {
            "layout": AdminLayout,
            "pagination": Pagination,
            "Link": Link,
            "AlertModal": AlertModal,
            "ConfirmModalWithPromise": ConfirmModalWithPromise,
            "ScrollHint": ScrollHint,
            //Svg
            SvgIconSearch,
            SvgIconDelete,
            SvgIconFile,
        },
        props: {
            user: Object,
            company: Object,
            companies: Array,
            freeText: Array,
            listSorter: Object,
        },
        data() {
            return {
                free_text: '',
                showPagination: false,
                list_sorter: {column: "", order: ""},
                showAlertModal: false,
                alert_modal_title: '',
                alert_modal_message: '',
                alert_modal_mode: ''
            }
        },
        computed: {
            pageType() {
                if (location.pathname == '/admin/shop-company') {
                    return 1;
                } else if (location.pathname == '/admin/brand-company') {
                    return 2;
                } else if (location.pathname == '/admin/not-login/shop-company') {
                    return 3;
                } else if (location.pathname == '/admin/not-login/brand-company') {
                    return 4;
                } else if (location.pathname == '/admin/showroom-company') {
                    return 5;
                } else if (location.pathname == '/admin/not-login/showroom-company') {
                    return 6;
                }
            },
            companiesList()  {
                if (this.companies.data) {
                    this.showPagination = true;
                }
                if (this.freeText) {
                    for(var i in this.companies.links) {
                        var link = this.companies.links[i];
                        if (link.url) {
                            link.url = link.url + '&freeText=' + this.freeText;
                        }
                    }
                }
                if (this.listSorter) {
                    this.addSorterToLinks(this.listSorter, this.companies.links);
                }
                return this.companies.data;
            },
            pageTitle() {
                if (location.pathname == '/admin/shop-company') {
                    return 'ショップ運営会社一覧';
                } else if (location.pathname == '/admin/brand-company') {
                    return 'ブランド運営会社一覧';
                } else if (location.pathname == '/admin/showroom-company') {
                    return 'ショールーム運営会社一覧';
                } else if (location.pathname == '/admin/not-login/shop-company') {
                    return '1年間ログインのないショップ運営会社一覧';
                } else if (location.pathname == '/admin/not-login/brand-company') {
                    return '1年間ログインのないブランド運営会社一覧';
                } else if (location.pathname == '/admin/not-login/showroom-company') {
                    return '1年間ログインのないショールーム運営会社一覧';
                }
            },
            linkToList() {
                if (location.pathname == '/admin/shop-company') {
                    return 'admin.shop.list';
                } else if (location.pathname == '/admin/brand-company') {
                    return 'admin.brand.list';
                } else if (location.pathname == '/admin/showroom-company') {
                    return 'admin.showroom.list';
                } else if (location.pathname == '/admin/not-login/shop-company') {
                    return 'admin.shop.list';
                } else if (location.pathname == '/admin/not-login/brand-company') {
                    return 'admin.brand.list';
                } else if (location.pathname == '/admin/not-login/showroom-company') {
                    return 'admin.showroom.list';
                }
            },
            backName() {
                if (this.user.type == 0) {
                    return 'Admin';
                } else if (this.user.type == 1) {
                    return 'Shop';
                } else if (this.user.type == 2) {
                    return 'Brand';
                } else if (this.user.type == 3) {
                    return 'ShowRoom';
                }
            },
        },
        mounted() {
            this.free_text = this.freeText;
            if(this.listSorter){
                this.list_sorter = this.listSorter;
            };
            new ScrollHint('.table_common');
        },
        methods: {
            search() {
                var url = location.pathname;
                const form = reactive({
                    freeText: this.free_text,
                    listSorter: this.list_sorter
                })
                Inertia.get(url, form, {
                    onSuccess: (page) => {
                        this.free_text = '';
                    },
                })
            },
            clickSort(sorter){
                if(this.list_sorter.column !== sorter){ // 1回目クリックされたらascでソート
                    this.list_sorter.column = sorter;
                    this.list_sorter.order = "ASC";
                } else {
                    if(this.list_sorter.order == "ASC"){
                        this.list_sorter.order = "DESC"; // 2回目クリックされたらdescでソート
                    } else {
                        this.list_sorter.column = ""; // 3回目クリックされたらソートを外す
                        this.list_sorter.order = "";
                    }
                }
                const { column, order } = this.list_sorter;
                const form = reactive({
                    freeText: this.free_text,
                    listSorter: { column, order }
                })
                Inertia.get(location.pathname, form);
            },
            addSorterToLinks(sorter, links){
                for(var i in links) {
                    var link = links[i];
                    if (link.url) {
                        link.url = link.url + `&listSorter[column]=${sorter.column}&listSorter[order]=${sorter.order}`;
                    }
                }
            },
            getTriangle(name){
                if(name == this.list_sorter.column){
                    return this.list_sorter.order == "ASC" ? "▼" : "▲";
                } else return "▼";
            },
            async clickDeleteCompany(company) {
                let plan_check = true;

                for(let i in company.brands) {
                    let brand = company.brands[i];
                    // basicプラン
                    if (brand.plan == 1 && brand.subscription_status == 'active') {
                        plan_check = false;
                    }
                }
                if (!plan_check) {
                    this.openAlertModal("error", "プランのキャンセルが必要です", 'お支払い中のbasicプランがあります。退会するにはプランのキャンセルが必要です。'); //確認済み
                    return;
                }
                const confirm = await this.$refs.confirmModal.show({ // 確認済み
                    title: '退会してもよろしいですか？',
                    message: "本当に退会してもよろしいですか？",
                    mode: "confirm",
                    name: "companyListConfirm"
                })
                if (confirm) {
                    if (this.pageType == 1 || this.pageType == 3) {
                        var routeName = 'admin.shop.company.delete';
                    } else if (this.pageType == 2 || this.pageType == 4) {
                        var routeName = 'admin.brand.company.delete';
                    } else if (this.pageType == 5 || this.pageType == 6) {
                        var routeName = 'admin.showroom.company.delete';
                    }

                    axios.post(route(routeName), {
                        company_id: company.id,
                    }).then((res) => {
                        this.openAlertModal("success", "退会しました", '退会しました。'); // 確認済み
                        setTimeout(function() { location.reload(); }, 2000); // modalを見る時間確保
                    })
                }
            },
            clickNotLoginList() {
                if (this.pageType == 1) {
                    var url = '/admin/not-login/shop-company';
                    location.href= url;
                } else if (this.pageType == 2) {
                    var url = '/admin/not-login/brand-company';
                    location.href= url;
                } else if (this.pageType == 5) {
                    var url = '/admin/not-login/showroom-company';
                    location.href= url;
                }
            },
            openAlertModal(mode, title, message) {
                this.alert_modal_mode = mode;
                this.alert_modal_title = title;
                this.alert_modal_message = message;
                this.showAlertModal = true;
            },
            closeAlertModal() {
                this.showAlertModal = false;
                this.alert_modal_mode = '';
                this.alert_modal_title = '';
                this.alert_modal_message = '';
            },
        }
    }
</script>
